<template>
  <div class="controls">
    <div class="controls__start">
      <span v-if="loading" class="controls__count">Tasks</span>
      <span v-else class="controls__count">{{ `Task (${reviewTasks.length})` }}</span>
    </div>
    <div class="controls__end">
      <div class="controls__actions">
        <button class="button button-sm" @click="openCreateTaskModal">New Task</button>
      </div>
    </div>
  </div>
  <div v-if="!loading" class="reviewTask__container">
    <div class="reviewTask__row">
      <div class="col-sm task-column">
        <div class="task-column__header">
          <span>Open</span>
        </div>
        <div class="task-column__body scrollbar">
          <ReviewTaskCard
            v-for="(task,i) in reviewTasks.filter(e => e.remainingCount && 0 < e.remainingCount['remaining_images']
              && e.remainingCount['remaining_images'] === e.remainingCount['total_images']).sort((a,b) => b.id - a.id)"
            :key="i"
            :task="task"
            :hasPermission="shouldAccessTask(task)"
            :datasets="datasets"
            @click="startEditing(task, 'image')"
            @start-image-review-task="startEditing(task, 'image')"
            @start-annotation-review-task="startEditing(task, 'annotation')"
            @open-manage-access="handleOpenManageAccess(task)"
            @delete-review-task="openConfirmDeleteTaskModal(task)"
          />
        </div>
      </div>
      <div class="col-sm task-column">
        <div class="task-column__header">
          <span>In Progress</span>
        </div>
        <div class="task-column__body scrollbar">
          <ReviewTaskCard
            v-for="(task,i) in reviewTasks.filter(e => e.remainingCount && 0 < e.remainingCount['remaining_images']
              && e.remainingCount['remaining_images'] < e.remainingCount['total_images']).sort((a,b) => b.id - a.id)"
            :key="i"
            :task="task"
            :hasPermission="shouldAccessTask(task)"
            :datasets="datasets"
            @click="startEditing(task, 'image')"
            @start-image-review-task="startEditing(task, 'image')"
            @start-annotation-review-task="startEditing(task, 'annotation')"
            @open-manage-access="handleOpenManageAccess(task)"
            @delete-review-task="openConfirmDeleteTaskModal(task)"
          />
        </div>
      </div>
      <div class="col-sm task-column">
        <div class="task-column__header">
          <span>Completed</span>
        </div>
        <div class="task-column__body scrollbar">
          <ReviewTaskCard
            v-for="(task,i) in reviewTasks.filter(e => e.remainingCount && (e.remainingCount['remaining_images'] === 0
              || e.remainingCount['total_images'] === 0)).sort((a,b) => b.id - a.id)"
            :key="i"
            :task="task"
            :hasPermission="shouldAccessTask(task)"
            :datasets="datasets"
            @click="startEditing(task, 'image')"
            @start-image-review-task="startEditing(task, 'image')"
            @start-annotation-review-task="startEditing(task, 'annotation')"
            @open-manage-access="handleOpenManageAccess(task)"
            @delete-review-task="openConfirmDeleteTaskModal(task)"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="empty-state">
    <InlineLoader
      :width="'60px'"
      :height="'60px'"
      :border="'12px'"
    />
  </div>
  <CreateAnnotationReviewTaskModal
    v-if="showCreateModal"
    ref="createAnnotationReviewTaskModal"
    v-model:reviewSettings="reviewSettings"
    :datasets="datasets"
    @review-task-created="handleReviewTaskCreated"
    @review-task-created-error="handleReviewTaskCreatedError"
    @closed="() => {showCreateModal = false;}"
  />
  <ConfirmModal
    ref="confirmModal"
    :messageHeader="confirmMessageHeader"
    :message="confirmMessage"
    :buttonClass="'button-delete'"
    :buttonText="buttonText"
    @confirmed="handleDeleteReviewTask"
  />
  <ManageReviewsAccess
    ref="manageReviewsAccessModal"
    :modalTask="modalTask"
    @refresh-tasks="updateAllReviewCards"
  />
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import ReviewTaskCard from '@/components/ReviewsPage/ReviewTaskCard.vue';
import CreateAnnotationReviewTaskModal from '@/components/ReviewsPage/CreateAnnotationReviewTaskModal.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import ManageReviewsAccess from '@/components/ReviewsPage/ManageReviewsAccess.vue';
import InlineLoader from '@/components/InlineLoader.vue';
import { useProjectsDatasetsStore } from '@/stores/useProjectsDatasetsStore';

export default {
  name: "ReviewsTab",
  components: {
    CreateAnnotationReviewTaskModal,
    ReviewTaskCard,
    ConfirmModal,
    ManageReviewsAccess,
    InlineLoader,
  },
  props: {
  },
  emits: [],
  data() {
    return {
      filters: {},
      dataConnect: null,
      reviewTasks: [],
      reviewSettings: null,
      editorLabels: [],
      confirmMessage: null,
      confirmMessageHeader: null,
      buttonText: "",
      toDelete: null,
      modalTask: null,
      showCreateModal: false,
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    currentProject() {
      return this.$store.state.projects.currentProject;
    },
    datasets() {
      return this.$store.state.datasets.datasetList;
    },
  },
  watch: {
    currentProject() {
      this.updateAllReviewCards();
    },
  },
  created() {
    this.dataConnect = new DatastoreConnect(this.$store.state.enterpriseServerUrl);
  },
  async mounted() {


   const resp = await this.dataConnect.getDatasetList(
    {
        project_id: this.currentProject?.id,
        get_parked: false,
        get_annotation_sets: true,
        get_labels: true,
        get_groups: true,
      }
   );
   if (resp.result){
      this.$store.commit('datasets/setDatasetList', resp.result);
   }
   


    this.updateAllReviewCards();
  },
  methods: {
    shouldAccessTask(task) {
      return true;
    },
    handleOpenManageAccess(task) {
      this.modalTask = task;
      this.$nextTick(() => {
        this.$refs.manageReviewsAccessModal.showModal();
      });
    },
    openConfirmDeleteTaskModal(t) {
      this.confirmMessage = `Are you sure you want to move task "${t.name}" to recycle bin?`;
      this.confirmMessageHeader = 'Remove Task';
      this.buttonText = "Remove";
      this.toDelete = t;
      this.$refs.confirmModal.showModal();
    },
    async updateAllReviewCards() {
      this.reviewTasks = await this.getReviewTasks();

      const updatedTasksPromises = this.reviewTasks.map(async (task) => {
        task.remainingCount = await this.getReviewTaskRemainingCount(task);
        return task;
      });
      this.reviewTasks = await Promise.all(updatedTasksPromises);

      if (this.modalTask) {
        const t = this.reviewTasks.find((e) => e.id === this.modalTask.id);
        if (t) {
          this.modalTask = t;
        }
      }
    },
    async getReviewTasks() {
      this.loading = true;
      const resp = await this.dataConnect.getReviewTasks({ project_id: this.currentProject?.id })
        .catch((error) => {
          // TODO: handle error
          this.loading = false;
          console.log(error);
        });
      if (resp.error || !resp.result) {
        // TODO: handle error
        this.loading = false;
        return {};
      }
      this.loading = false;
      return resp.result;
    },
    async getReviewTaskRemainingCount(reviewTask) {
      const params = {
        review_task_id: reviewTask.id,
        dataset_id: reviewTask.dataset_id,
      };
      let remainingCount;
      if (reviewTask?.type === 'audit') {
        remainingCount = await this.dataConnect.getReviewTaskRemainingCount(params)
          .catch((error) => {
          // TODO: handle error
            console.log(error);
          });
      } else if (reviewTask?.type === 'label') {
        remainingCount = await this.dataConnect.getLabelingTaskRemainingCount(params)
          .catch((error) => {
          // TODO: handle error
            console.log(error);
          });
      }

      if (remainingCount.error || !remainingCount.result) {
        // TODO: handle error
        return {};
      }
      return remainingCount.result;
    },
    async handleReviewTaskCreated() {
      this.updateAllReviewCards();
    },
    async handleReviewTaskCreatedError(error) {
      if (error.message.includes("limit reached")) {
        this.confirmMessage = `You haved reached the limit for number of tasks. Delete unused tasks or upgrade your package.`;
        this.confirmMessageHeader = 'Limit Reached';
        this.buttonText = "";
        this.$refs.confirmModal.showModal();
      }
    },
    async handleDeleteReviewTask() {
      const resp = await this.dataConnect.deleteReviewTask({ review_task_id: this.toDelete.id })
        .catch((error) => {
          // TODO: handle error
          console.log(error);
        });
      if (!resp || resp.error || !resp.result) {
        if (resp.error) {
          window.alert(resp.error);
        }
      }
      this.updateAllReviewCards();
    },
    openCreateTaskModal() {
      this.showCreateModal = true;
    },
    async startEditing(reviewTask, initialAuditorType) {
      const access = await this.shouldAccessTask(reviewTask);
      if (!access) {
        return;
      }

      this.$router.push({
        name: 'annotator.editor',
        query: {
          auditorType: initialAuditorType,
          reviewTaskId: reviewTask.id,
        },
        params: {
          projectId: this.currentProject.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.controls {
  display: flex;
  margin: 20px 20px 0 20px;
  align-items: center;

  &__count {
    font-weight: bold;
    font-size: 1rem;
  }

  &__start {
    display: flex;
    justify-content: flex-start;
    width: fit-content;
    gap: 10px;
  }

  &__end {
    display: flex;
    justify-content: flex-end;
    flex: 1;
  }

  &__actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    height: 100%;
  }
}

.reviewTask {

  &__container {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
    min-width: 500px;
    position: relative;
    min-height: 0;

    .task-column {
      display: flex;
      flex-direction: column;
      @include themify() {
        background: radial-gradient(circle, rgba($color-primary-400, 0.075) 50%, rgba(var(--color-primary-rgb), 0.125) 100%);
      }
      max-width: 33%;
      border-radius: 10px;

      &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 16px 16px 6px 16px;
        font-size: 1.4rem;
        font-weight: 700;
      }

      &__body {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        padding: 4px 16px;
        margin-bottom: 20px;
        overflow-y: auto;
        gap: 16px
      }
    }
  }

  &__row {
    display: flex;
    flex-direction: row;
    height: 100%;
    padding: 16px;
    gap: 16px;
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
